import { createSelector, createStructuredSelector } from 'reselect'
import { createFormTargetSelector } from '../../commons/FormReducer/utils'
import { createTargetDataSelector as createTargetFormSelector } from '../../commons/FormReducer/reducer'
import { createReduxTargetSelector, createGetState } from '../../commons/Redux/selector'
import { createFetchedTargetSelector } from '../../commons/fetch/FetchComponent/utils'
import {
    createTargetDataSelector as createTargetFetchSelector,
    createTargetFetchCompleteSelector,
    createTargetFetchSuccessSelector
} from '../../commons/fetch/FetchComponent/reducer'

// export const url = '/api/session'

export const mapStateToProps = () => {

    const formTarget = createFormTargetSelector()
    const formData = createTargetFormSelector(formTarget)
    const storeTargetForm = createReduxTargetSelector(formTarget)
    const fetchedTarget = createFetchedTargetSelector()
    const storeTargetFetched = createReduxTargetSelector(fetchedTarget)
    const fetchedData = createTargetFetchSelector(fetchedTarget)
    const fetchComplete = createTargetFetchCompleteSelector(fetchedTarget)
    const fetchSuccess = createTargetFetchSuccessSelector(fetchedTarget)

    const action = createSelector(
        formData,
        data => data && data.get('action')
    )

    const disable = createSelector(
        action,
        (action$) => action$ !== 'test-get' && action$ !== 'test-entity'
    )

    const url = createSelector(
        action,
        (action$) =>
            action$ === 'test-get'
                ? '/api/test-get'
                : action$ === 'test-db'
                    ? '/api/test-db'
                    : null
    )

    const fetchProps = createStructuredSelector({
        storeTarget: storeTargetFetched,
        url,
        disable
    })


    const mapLocalStateToProps = createStructuredSelector({
        storeTargetForm,
        storeTargetFetched,
        fetchProps,
        fetchedData,
        fetchComplete,
        fetchSuccess,
        action
    })

    return createSelector(
        createGetState(),
        (_, props) => props,
        mapLocalStateToProps
    )
}
